import React from 'react'
import { inject, observer } from 'mobx-react'
import { WMSTileLayer } from 'react-leaflet'
import densityLayers from 'densityLayers.js'

// Renders population density overlays. WMSTileLayer
// uses the props we pass it to construct tile URLs which
// geoserver serves.
const Overlays = ({ uiStore }) => (
  uiStore.densityLayer !== 'none'
    ? (
      <WMSTileLayer
        noWrap
        bounds={[[-90, -180], [90, 180]]}
        key={densityLayers.key}
        url={uiStore.densityLayerUrl}
        layers={uiStore.densityLayer}
        version={densityLayers.version}
        format={densityLayers.format}
        opacity={0.75}
        zIndex={2}
        transparent
        tiled
        tilesOrigin={[-90, -180]}
      />
      )
    : null
)

export default inject('uiStore')(
  observer(Overlays)
)
